<template>
  <div>
    <div class="mains" @click.stop="close()">
      <div class="comtainer" @click.stop>
        <div class="selectValue">
          <Space>
            <span style="
                  float: left;
                  height: 30px;
                  line-height: 30px;
                  margin-right: 10px;
                ">已选:</span>
            <div class="selectDiv" v-for="(item, index) in values" :key="index">
              <p v-text="item + '&ensp;X'" @click="delect(index)"></p>
            </div>
          </Space>
        </div>

        <div class="top">
          <div class="select">
            <Input v-model="selectVal" @on-search="search()" search placeholder="输入字段标题或ID" />
          </div>
        </div>
        <div class="main">
          <Table border :columns="columns" :data="pageData" style="width: 100%; height: 100%">
            <template #action="{ index }">
              <Button type="success" @click="show(index)">选择</Button>
            </template>
          </Table>
          <!-- 分页 -->
          <Page class="page" :modelValue="pages" :total="allPage" simple @on-change="page" />
          <Button @click="setAssign()" type="success" style="width: 100px; height: 40px">保&nbsp;存</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetFiledList } from "@/api/index";
export default {
  props: ["FiledData"],
  data() {
    return {
      values: [],
      columns: [
        {
          title: "id",
          key: "id",
          width: 65,
        },
        {
          title: "字段类型",
          key: "dataType",
          width: 120,
        },
        {
          title: "字段标题",
          key: "title",
          width: 200,
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 200,
        },
        {
          title: "添加时间",
          key: "time",
          width: 200,
        },
        {
          title: " ",
          slot: "action",
          width: 120,
          align: "center",
          fixed: "right",
        },
      ],
      // 分页后的数据
      pageData: [],
      pages: 1,
      allPage: 1,
      selectVal: "",
    };
  },
  mounted() {
    if (this.FiledData !== "") {
      this.values = this.FiledData.split(",");
    }
  },
  watch: {},
  computed: {
    SelectValue() {
      var str = "";
      for (let index = 0; index < this.values.length; index++) {
        str = str + this.values[index] + ",";
      }
      return str;
    },
  },
  created() {
    this.getFileds()
  },
  methods: {
    search() {
      this.getFileds()
    },
    // 获取字段信息
    getFileds() {
      GetFiledList({
        page: this.pages,
        pagesize: 10,
        name: this.selectVal
      }).then((res) => {
        this.pageData = res.list
        this.allPage = res.size
      });
    },
    delect(index) {
      this.values.splice(index, 1);
    },
    getFiledData() {
      this.values = this.FiledData.split(",");
    },
    setAssign() {
      var str = "";
      for (let index = 0; index < this.values.length; index++) {
        str = str + this.values[index] + ",";
      }
      str = str.slice(0, -1);
      this.$emit("Value", str);
      this.close();
    },
    show(index) {
      if (this.values.indexOf(this.pageData[index].id) == -1) {
        this.values.push(this.pageData[index].id);
      } else {
        // this.$message({type: "error",message: "已选择"});
        this.$Notice.error({ title: "已选择！" + this.pageData[index].title });
      }
    },
    close() {
      this.$emit("close", true);
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      this.getFileds()
    },
  },
};
</script>

<style  scoped>
.mains {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.comtainer {
  display: block;
  padding: 15px;
  width: 900px;
  height: auto;
  min-height: 700px;
  max-height: 700px;
  background: white;
}

.selectDiv {
  padding: 5px 5px 5px 5px;
  margin-right: 5px;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 5px;
  color: white;
  width: 50px;
  float: left;
}

.selectValue {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.top {
  width: 100%;
  background: white;
  padding: 15px;
}

.main {
  height: calc(100% - 100px);
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
